import { render, staticRenderFns } from "./HrHeroSplitStats.vue?vue&type=template&id=08af4f9a"
import script from "./HrHeroSplitStats.vue?vue&type=script&lang=js"
export * from "./HrHeroSplitStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports